// Strips accents/diacritics and case so visually-equivalent free-text values
// (e.g. "café" and "cafe", "Rijplaten" and "rijplaten") compare equal.
export function normalizeForCompare(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
}
